import React, { useState } from 'react';
import { IonApp, IonRouterOutlet, IonSplitPane, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router-dom';
import Menu from './components/Menu.js';
import Biblio from './pages/Biblio';
import Autores from './pages/Autores';
import Abrev from './pages/Abrev';
import Calculo from './pages/Calculo';
import Farmacos from './pages/Farmacos';
import Guia from './pages/Guia';
 
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
import {literales,literales_en} from './literales';

/* Theme variables */
import './theme/variables.css';
import './App.css';

setupIonicReact();

const App: React.FC = () => {
  const [lang, setLang] = useState('ES');
  const handlerLang=(lang:string)=>{
    console.log(lang);
    setLang(lang);
  }
  return (
    <IonApp>
      <IonReactRouter>
        <IonSplitPane contentId="main">
          <Menu lang={lang} handlerLang={handlerLang} literales={(lang==='ES') ? literales:literales_en} />
          <IonRouterOutlet id="main">
            <Route path={`${process.env.PUBLIC_URL}/`} exact={true}>
              <Redirect to={`${process.env.PUBLIC_URL}/arbol`} />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/arbol`} exact={true}>
              <Calculo lang={lang} literales={(lang==='ES') ? literales:literales_en} />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/autores`} exact={true}>
              <Autores lang={lang} />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/farmacos`} exact={true}>
              <Farmacos lang={lang} />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/abrev`} exact={true}>
              <Abrev  lang={lang}/>
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/biblio`} exact={true}>
              <Biblio  lang={lang}/>
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/guia`} exact={true}>
              <Guia  lang={lang}/>
            </Route>
          </IonRouterOutlet>
        </IonSplitPane>
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
